// 숫자·차량번호·URL·날짜 LTR 격리 — 아랍어 셸에서도 순서가 뒤집히면 안 되는 값 (신고 371 시안 `.num`).
import React from 'react';

var base = { direction: 'ltr', unicodeBidi: 'isolate', fontVariantNumeric: 'tabular-nums' };

function LtrText(props) {
  return <span className="ss-ltr" style={props.style ? Object.assign({}, base, props.style) : base}>{props.children}</span>;
}

export default LtrText;
